import { getRoutes } from '@ui-framework/index';
import AuthorizationWrapper, {
  authFnForMaintenancePages,
  authFnForMaintenanceCreatePages,
} from '@product-framework/components/AuthorizationWrapper';
import ServiceAdministratorWarrantyTypeEdit from './pages/edit/index';
import ServiceAdministratorWarrantyTypeCreate from './pages/create/index';
import ServiceAdministratorWarrantyTypeList from './pages/list/index';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';

import ServiceAdministratorWarrantyTypeFormStore from './store/index';

const Pages = ProtectedRoute => ({
  ServiceAdministratorWarrantyTypeEdit: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceAdministratorWarrantyTypeEdit}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnForMaintenancePages],
      }}
    />
  ),
  ServiceAdministratorWarrantyTypeCreate: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceAdministratorWarrantyTypeCreate}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnForMaintenanceCreatePages],
      }}
    />
  ),
  ServiceAdministratorWarrantyTypeList: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceAdministratorWarrantyTypeList}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnForMaintenancePages],
      }}
    />
  ),
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

const stores = rootStore => [
  {
    serviceadministratorwarrantytypeFormStore:
      new ServiceAdministratorWarrantyTypeFormStore(rootStore),
  },
];

export {
  ServiceAdministratorWarrantyTypeEdit,
  ServiceAdministratorWarrantyTypeCreate,
  ServiceAdministratorWarrantyTypeList,
  routes,
  stores,
};
